import axios from '../../../utilities/axios';
import {QuestionDto} from '../../../models/dtos/question.dto';

export const getCurrentQuestionRequest = async (): Promise<QuestionDto> => {
  try {
    const response = await axios.get<QuestionDto>(
      `${process.env.REACT_APP_BASE_URL}/questions/current`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
